import { TComplainComplaintsFetched, TComplainComplaintSended } from '../../actions/complain';
import { Action } from 'redux';

export type TComplainRequest = 'complain/request';
export type TComplainFailRequest = 'complain/failRequest';
export type TComplainChangeVisibility = 'complain/changeVisibility';

export interface IComplainRequest extends Action<TComplainRequest> {
  offerId: number;
  type: TComplainRequest;
}

export interface IComplainFailRequest extends Action<TComplainFailRequest> {
  offerId: number;
  error: string;
  type: TComplainFailRequest;
}

export interface IComplainChangeVisibility extends Action<TComplainChangeVisibility> {
  offerId: number;
  isVisible: boolean;
  type: TComplainChangeVisibility;
}

export const COMPLAIN_REQUEST: TComplainRequest = 'complain/request';
export const COMPLAIN_FAIL_REQUEST: TComplainFailRequest = 'complain/failRequest';
export const COMPLAIN_COMPLAINTS_FETCHED: TComplainComplaintsFetched = 'complain/complaintsFetched';
export const COMPLAIN_COMPLAINT_SENDED: TComplainComplaintSended = 'complain/complaintSended';
export const COMPLAIN_CHANGE_VISIBILITY: TComplainChangeVisibility = 'complain/changeVisibility';
